(function () {
    'use strict';

    angular
        .module('app.deleteCustomReport', [])
        .controller('deleteCustomReportCtrl', ['$scope', '$rootScope', '$modal', '$modalInstance', 'deleteCustomReportService',
            function ($scope, $rootScope, $modal, $modalInstance, deleteCustomReportService) {

                $scope.confirmDelete = function() {
                    deleteCustomReportService.deleteCustomReport($scope.reportId, $scope.selectedAdvertiser, true)
                        .then(function(response) {
                            $scope.deleteCustomReportModalInstance.close();
                            if($scope.detailCustomReportModalInstance != null) {
                                $scope.detailCustomReportModalInstance.close();
                            }

                            $scope.sendHttpRequest();
                        }, function(response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.closeModal = function() {
                    $modalInstance.close();
                }
            }
        ]);
})();